<template>
  <div ref="scroll" class="ai-messages" aria-label="Chat messages" @scroll="trackScroll">
    <button v-if="chat.nextBefore" class="ai-messages__older" type="button" :disabled="chat.loading" @click="$emit('older')">Load earlier messages</button>
    <p v-if="!chat.messages.length" class="ai-messages__empty">{{ chat.loading && !chat.loaded ? 'Loading messages…' : 'Ask Knowledge AI a question. Lead details are not included automatically.' }}</p>
    <article v-for="message in chat.messages" :key="message.id" class="ai-message" :class="`ai-message--${message.role}`">
      <header>{{ message.role === 'user' ? 'You' : 'Knowledge AI' }} <time :datetime="message.created_at">{{ time(message.created_at) }}</time></header>
      <p>{{ message.text }}</p>
      <footer v-if="message.role === 'user'">
        <span>{{ status(message.operation) }}</span>
        <button v-if="message.operation.retry_allowed" type="button" :disabled="Boolean(chat.retrying)" @click="$emit('retry', message)">Retry request</button>
      </footer>
    </article>
  </div>
</template>

<script>
import { messageStatus } from './model'

export default {
  name: 'KnowledgeChatMessages',
  props: { chat: { type: Object, required: true } },
  data() {
    return { nearBottom: true }
  },
  watch: {
    'chat.messages'() {
      if (this.nearBottom) this.$nextTick(this.bottom)
    }
  },
  mounted() { this.bottom() },
  methods: {
    status: messageStatus,
    time(value) { return new Date(value).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) },
    trackScroll() {
      const el = this.$refs.scroll
      this.nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 70
    },
    bottom() {
      const el = this.$refs.scroll
      if (el) el.scrollTop = el.scrollHeight
    },
    async preserveScroll(load) {
      const el = this.$refs.scroll
      const height = el.scrollHeight
      const top = el.scrollTop
      this.nearBottom = false
      await load()
      await this.$nextTick()
      el.scrollTop = top + el.scrollHeight - height
    }
  }
}
</script>

<style scoped>
.ai-messages { flex: 1; overflow-y: auto; min-height: 0; padding: 16px; background: #f6f8fb; }
.ai-messages__empty { color: #6b778b; line-height: 1.6; margin: 24px 8px; }
.ai-message { margin-bottom: 14px; padding: 12px; border: 1px solid #e4e9f1; background: #fff; border-radius: 12px; overflow-wrap: anywhere; }
.ai-message--user { margin-left: 24px; background: #edf3ff; border-color: #dce7fc; }
.ai-message--assistant { margin-right: 12px; }
.ai-message header { display: flex; justify-content: space-between; font-size: 12px; font-weight: 600; gap: 8px; color: #475873; }
.ai-message time { font-weight: 400; }
.ai-message p { white-space: pre-wrap; line-height: 1.55; margin: 8px 0; }
.ai-message footer { display: flex; flex-direction: column; align-items: flex-start; gap: 6px; font-size: 11px; color: #697891; }
.ai-message button, .ai-messages__older { border: 0; background: transparent; color: #295ba8; text-decoration: underline; padding: 4px 0; cursor: pointer; }
.ai-messages__older { display: block; margin: 0 auto 14px; }
</style>
